export const SITE = {
  doctor: "Tatiana Nakryzhskaya, MD, PhD, CFMP",
  specialty: {
    ru: "Врач превентивной и функциональной медицины",
    en: "Preventive & Functional Medicine Physician",
    cs: "Lékařka preventivní a funkční medicíny",
  },
  city: { ru: "Прага, Чехия", en: "Prague, Czech Republic", cs: "Praha, Česká republika" },
  email: "info@tatiananakryzhskaya.com",
  phone: "",
  calendarUrl: "https://rezervace.navstevalekare.cz/topmedica",
  ifmvUrl: "https://my.medevio.cz/institut-funkcni-mediciny-a-vyzivy/",
  clarityId: "yxkbmv1o9c",
  gaId: "G-Q6ET996PP5",
  siteUrl: "https://tatiananakryzhskaya.com",
  socials: {
    instagram: "https://www.instagram.com/md_tatiana_nakryzhskaya/",
    telegram: "",
    facebook: "",
  },
};

export const IMAGES = {
  portrait: "/images/doctor-hero.png?v=1",
  about: "/images/doctor-about.jpg?v=2",
  process: "/images/doctor-process.png?v=1",
};

export const CERTS = {
  badge: "/images/cfmp-badge.jpg",
  items: [
    { name: "CFMP — Certified Functional Medicine Practitioner", org: "Functional Medicine University", file: "" },
    { name: "Longevity Medicine 101", org: "Longevity Education", file: "/certificates/longevity-medicine-101.pdf" },
    { name: "Longevity Medicine 201", org: "Longevity Education", file: "/certificates/longevity-medicine-201.pdf" },
  ],
};

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
}
